// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__6ZVl1","tabHeader":"Tabs_tabHeader__azDSr","active":"Tabs_active__dR5pz","tabContent":"Tabs_tabContent__+siMh","inactive":"Tabs_inactive__u3uIy"};